<template>
  <div>
    <!-- 资格审查通过 -->
    <div class="flex-x-center">
      <div class="profile-content">
        <div class="iconfont icon-tongguo flex-x-y-center advisement-icon"></div>
        <div class="title flex-x-y-center">缴纳费用</div>
        <div v-for="(item, index) in process.content.fee_list" :key="index">
          <div class="title">{{ item.title }}</div>
          <el-table :data="item.order">
            <el-table-column prop="id" label="订单编号" width="250">
            </el-table-column>
            <el-table-column prop="title" label="订单类型"> </el-table-column>
            <el-table-column prop="money" label="订单金额"> </el-table-column>

            <el-table-column label="订单状态">
              <template v-slot="scope">
                <span v-show="scope.row.is_pay == '1'">已支付</span>
                <span v-show="scope.row.is_pay == '0'">未支付</span>
              </template>
            </el-table-column>

            <el-table-column prop="buy" label="操作">
              <template slot-scope="scope">
                <el-button v-show="scope.row.is_pay == '0'" @click="toPay(scope.row)" size="small">立即支付
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog title="是否已完成支付" :visible.sync="jfVisiblePay" width="30%" :before-close="handleClose">
      <span>请在新打开的页面中完成支付</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jfVisiblePay = false">取消支付</el-button>
        <el-button type="primary" @click="checkPayResult()">已完成支付</el-button>
      </span>
    </el-dialog>
    <div class="flex-x-center agree-sign-next">
      <button class="next-step" @click="$parent.next()">下一步</button>
    </div>
  </div>
</template>

<script>
import { reqFeePayResult } from "@/api";
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { erroralert, successalert } from "@/utils/alert";
export default {
  data() {
    return {
      order_id: 0,
      jfVisiblePay: false,
    };
  },

  props: {
    // 流程
    process_index: 0,
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  methods: {
    checkPayResult() {
      var order_id = this.order_id;
      reqFeePayResult(order_id).then((res) => {
        if (res.data.code === 1) {
          this.$message.success(res.data.msg);
          this.jfVisiblePay = false;
          this.$parent.reload();
          //调用父组件，进入下一步
        }
      });
    },
    toPay(order) {
      this.order_id = order.id;
      console.log(this.process);
      window.open(order.pay_url);
      this.jfVisiblePay = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
  },
};
</script>

<style scoped>
.qualifications {
  color: rgb(219, 122, 65);
  letter-spacing: 1px;
  margin-top: 20px;
}

.unpassd-icono {
  font-size: 60px;
  color: #b8000d;
}

.advisement-icon {
  font-size: 60px;
  color: rgb(37, 110, 206);
}

.pass-icon {
  font-size: 60px;
  color: rgb(50, 187, 62);
}

.profile-content {
  margin-top: 20px;
  width: 83%;
  padding: 40px 50px 80px;
  background: white !important;
  border-radius: 5px;
  box-sizing: border-box;
}
</style>
